/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type RateCardDropdown_rateCards$ref = any;
type expensesPage_company$ref = any;
type expensesPage_project$ref = any;
type ratesAndInternalCostPage_company$ref = any;
type ratesAndInternalCostPage_project$ref = any;
export type BUDGET_TYPE = "FIXED_PRICE" | "FIXED_PRICE_V2" | "NON_BILLABLE" | "RETAINER" | "TIME_AND_MATERIALS" | "%future added value";
export type LANGUAGE = "DANISH" | "ENGLISH_EU" | "ENGLISH_UK" | "ENGLISH_US" | "FRENCH" | "POLISH" | "SPANISH" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_HOURS" | "FIXED_PRICE" | "TIME_AND_MATERIALS" | "%future added value";
export type PROJECT_STATUS = "DONE" | "HALTED" | "OPPORTUNITY" | "PLANNING" | "RUNNING" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type projectBudgetV2_viewer$ref: FragmentReference;
declare export opaque type projectBudgetV2_viewer$fragmentType: projectBudgetV2_viewer$ref;
export type projectBudgetV2_viewer = {|
  +id: string,
  +actualPersonId: ?string,
  +language: ?LANGUAGE,
  +videosShown: ?$ReadOnlyArray<?string>,
  +availableFeatureFlags: ?$ReadOnlyArray<?{|
    +key: ?string
  |}>,
  +permissions: ?$ReadOnlyArray<?string>,
  +company: ?{|
    +id: string,
    +currency: ?string,
    +xeroEnabled: ?boolean,
    +newXeroEnabled: ?boolean,
    +modules: ?$ReadOnlyArray<?{|
      +moduleType: ?string
    |}>,
    +exchangeRates: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +currency: ?string,
          +rate: ?number,
        |}
      |}>
    |},
    +allPersons: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +email: ?string,
        |}
      |}>
    |},
    +rateCards: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +name: ?string,
          +defaultRate: ?number,
          +currency: ?string,
          +parentRateCardId: ?string,
          +rates: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +rate: ?number,
                +defaultRate: ?boolean,
                +startDate: ?string,
                +role: ?{|
                  +id: string,
                  +name: ?string,
                |},
              |}
            |}>
          |},
        |},
        +$fragmentRefs: RateCardDropdown_rateCards$ref,
      |}>
    |},
    +roles: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +name: ?string,
        |}
      |}>
    |},
    +expenseCategories: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +name: ?string,
          +disabled: ?boolean,
        |}
      |}>
    |},
    +$fragmentRefs: expensesPage_company$ref & ratesAndInternalCostPage_company$ref,
  |},
  +project: ?{|
    +id: string,
    +budgetType: ?BUDGET_TYPE,
    +budget: ?number,
    +defaultPeriodBudgetType: ?PERIOD_BUDGET_TYPE,
    +defaultPeriodPriceAmount: ?number,
    +companyProjectId: ?number,
    +name: ?string,
    +estimationUnit: ?string,
    +minutesPerEstimationPoint: ?number,
    +reportedBillablePrice: ?number,
    +currentCost: ?number,
    +forecastBillablePrice: ?number,
    +financialServiceUnInvoicedTotal: ?number,
    +originalForecastBillableHoursPrice: ?number,
    +forecastBillableHoursPrice: ?number,
    +forecastBillablePriceScopeBased: ?number,
    +forecastCost: ?number,
    +remainingCost: ?number,
    +reported: ?number,
    +forecastTotal: ?number,
    +remaining: ?number,
    +projectEndDay: ?number,
    +projectEndMonth: ?number,
    +projectEndYear: ?number,
    +projectStartDay: ?number,
    +projectStartMonth: ?number,
    +projectStartYear: ?number,
    +projectFirstDateYear: ?number,
    +projectFirstDateMonth: ?number,
    +projectFirstDateDay: ?number,
    +projectLastDateYear: ?number,
    +projectLastDateMonth: ?number,
    +projectLastDateDay: ?number,
    +billable: ?boolean,
    +taskCostCalculationType: ?string,
    +unassignedTaskHourlyCost: ?number,
    +status: ?PROJECT_STATUS,
    +baselineCost: ?number,
    +baselineProfit: ?number,
    +baselineTargetMinutes: ?number,
    +useBaseline: ?boolean,
    +completion: ?number,
    +timeRegBasedPlusDoneScopeCompletion: ?number,
    +valueBasedProgress: ?number,
    +financialDataAvailability: ?number,
    +financialNumbers: ?{|
      +totalRateValue: ?number,
      +budgetVsTotalRateValue: ?number,
    |},
    +company: ?{|
      +roles: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: ?string,
          |}
        |}>
      |},
      +modules: ?$ReadOnlyArray<?{|
        +moduleType: ?string
      |}>,
      +expenseCategories: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: ?string,
          |}
        |}>
      |},
    |},
    +xeroInvoices: ?$ReadOnlyArray<?{|
      +id: string,
      +amountTotal: ?number,
      +amountNoTax: ?number,
      +amountPaid: ?number,
    |}>,
    +registeredMinutesPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +remainingMinutesPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +plannedMinutesPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +costPlannedPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +pricePlannedPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +costRemainingPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +priceRemainingPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +costActualPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +priceActualPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +costPlannedWorkPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +pricePlannedWorkPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +costRemainingWorkPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +priceRemainingWorkPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +costActualWorkPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +priceActualWorkPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +pricePlannedExpensesPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +costPlannedExpensesPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +priceActualExpensesPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +costActualExpensesPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +priceRemainingExpensesPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +costRemainingExpensesPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +invoicedPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +totalPaymentsPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +baselinePricePerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +baselineCostPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +baselineProfitPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +baselineMinutesPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +baselineUnplannedPricePerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +baselineUnplannedMinutesPerDay: ?$ReadOnlyArray<?{|
      +date: ?string,
      +value: ?number,
    |}>,
    +breakdownForecastMinutesPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownRemainingMinutesPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownActualMinutesPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownCostForecastPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownCostRemainingPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownCostActualPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownPricePlannedPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownPriceRemainingPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownPriceActualPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownCostForecastWorkPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownCostRemainingWorkPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownCostActualWorkPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownPricePlannedWorkPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownPriceRemainingWorkPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownPriceActualWorkPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownBaselinePricePerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownBaselineCostPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownBaselineProfitPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownBaselineMinutesPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: ?string,
      +roleBreakdown: ?$ReadOnlyArray<?{|
        +roleId: ?string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownBaselineExpensesPricePerDay: ?$ReadOnlyArray<?{|
      +milestoneId: string,
      +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
        +expenseCategoryId: string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownBaselineExpensesCostPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: string,
      +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
        +expenseCategoryId: string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownExpensesPlannedPricePerDay: ?$ReadOnlyArray<?{|
      +milestoneId: string,
      +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
        +expenseCategoryId: string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownExpensesActualsPricePerDay: ?$ReadOnlyArray<?{|
      +milestoneId: string,
      +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
        +expenseCategoryId: string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownExpensesRemainingPricePerDay: ?$ReadOnlyArray<?{|
      +milestoneId: string,
      +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
        +expenseCategoryId: string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownExpensesPlannedCostPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: string,
      +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
        +expenseCategoryId: string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownExpensesActualsCostPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: string,
      +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
        +expenseCategoryId: string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +breakdownExpensesRemainingCostPerDay: ?$ReadOnlyArray<?{|
      +milestoneId: string,
      +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
        +expenseCategoryId: string,
        +breakdown: ?$ReadOnlyArray<?{|
          +date: ?string,
          +value: ?number,
        |}>,
      |}>,
    |}>,
    +warnings: ?$ReadOnlyArray<?{|
      +id: ?string,
      +year: ?number,
      +month: ?number,
      +day: ?number,
      +tasks: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: ?string,
            +startDay: ?number,
            +startMonth: ?number,
            +startYear: ?number,
            +deadlineDay: ?number,
            +deadlineMonth: ?number,
            +deadlineYear: ?number,
            +estimateLow: ?number,
            +estimateHigh: ?number,
            +estimateForecast: ?number,
          |}
        |}>
      |},
      +personIds: ?$ReadOnlyArray<?string>,
      +expenseItems: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: ?string,
            +expenseYear: ?number,
            +expenseMonth: ?number,
            +expenseDay: ?number,
          |}
        |}>
      |},
      +timeRegistrations: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +year: ?number,
            +month: ?number,
            +day: ?number,
            +minutesRegistered: ?number,
            +person: ?{|
              +id: string,
              +fullName: ?string,
              +profilePictureId: ?string,
              +profilePictureDefaultId: ?number,
            |},
            +task: ?{|
              +name: ?string
            |},
          |}
        |}>
      |},
    |}>,
    +tasks: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +name: ?string,
          +role: ?{|
            +id: string
          |},
          +estimateLow: ?number,
          +estimateHigh: ?number,
          +estimateForecast: ?number,
          +assignedPersons: ?$ReadOnlyArray<?{|
            +id: string
          |}>,
        |}
      |}>
    |},
    +rateCard: ?{|
      +id: string,
      +currency: ?string,
      +name: ?string,
      +defaultRate: ?number,
      +parentRateCardId: ?string,
      +rates: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +rate: ?number,
            +defaultRate: ?boolean,
            +startDate: ?string,
            +role: ?{|
              +id: string,
              +name: ?string,
            |},
          |}
        |}>
      |},
    |},
    +phases: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +name: ?string,
          +startDay: ?number,
          +startMonth: ?number,
          +startYear: ?number,
          +deadlineDay: ?number,
          +deadlineMonth: ?number,
          +deadlineYear: ?number,
        |}
      |}>
    |},
    +fixedPriceLocks: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +startDate: ?string,
          +endDate: ?string,
          +actualRevenueProjectCurrency: ?number,
          +progress: ?number,
        |}
      |}>
    |},
    +expenseItems: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +category: ?{|
            +id: string,
            +name: ?string,
          |},
          +phase: ?{|
            +id: string,
            +name: ?string,
          |},
          +name: ?string,
          +approved: ?boolean,
          +expenseYear: ?number,
          +expenseMonth: ?number,
          +expenseDay: ?number,
          +billable: ?boolean,
          +price: ?number,
          +cost: ?number,
          +quantity: ?number,
          +planned: ?boolean,
          +createdAt: ?string,
          +invoiced: ?boolean,
          +person: ?{|
            +id: string,
            +fullName: ?string,
            +profilePictureId: ?string,
            +profilePictureDefaultId: ?number,
          |},
        |}
      |}>
    |},
    +projectPersons: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +person: ?{|
            +id: string,
            +isViewer: ?boolean,
            +fullName: ?string,
            +initials: ?string,
            +profilePictureId: ?string,
            +profilePictureDefaultId: ?number,
            +active: ?boolean,
            +userType: ?string,
            +permissions: ?$ReadOnlyArray<?string>,
            +costPeriods: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +startDay: ?number,
                  +startMonth: ?number,
                  +startYear: ?number,
                  +cost: ?number,
                |}
              |}>
            |},
          |},
          +role: ?{|
            +id: string,
            +name: ?string,
          |},
        |}
      |}>
    |},
    +invoices: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +status: ?string
        |}
      |}>
    |},
    +$fragmentRefs: expensesPage_project$ref & ratesAndInternalCostPage_project$ref,
  |},
  +$refType: projectBudgetV2_viewer$ref,
|};
export type projectBudgetV2_viewer$data = projectBudgetV2_viewer;
export type projectBudgetV2_viewer$key = {
  +$data?: projectBudgetV2_viewer$data,
  +$fragmentRefs: projectBudgetV2_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Module",
  "kind": "LinkedField",
  "name": "modules",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "moduleType",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 10000
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultRate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentRateCardId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v11 = [
  (v0/*: any*/),
  (v7/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "RateTypeConnection",
  "kind": "LinkedField",
  "name": "rates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RateTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Rate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v6/*: any*/),
            (v8/*: any*/),
            (v10/*: any*/),
            (v12/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "rates(first:10000)"
},
v14 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "RoleTypeConnection",
  "kind": "LinkedField",
  "name": "roles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoleTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v11/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "roles(first:10000)"
},
v15 = [
  {
    "kind": "Literal",
    "name": "newBudget",
    "value": true
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v18 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "date",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "milestoneId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "breakdown",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v21 = [
  (v19/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "BudgetRoleBreakdownType",
    "kind": "LinkedField",
    "name": "roleBreakdown",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roleId",
        "storageKey": null
      },
      (v20/*: any*/)
    ],
    "storageKey": null
  }
],
v22 = [
  (v19/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "BudgetExpenseCategoryBreakdownType",
    "kind": "LinkedField",
    "name": "expenseCategoryBreakdown",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expenseCategoryId",
        "storageKey": null
      },
      (v20/*: any*/)
    ],
    "storageKey": null
  }
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateLow",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateHigh",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecast",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseYear",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseMonth",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseDay",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v38/*: any*/),
    (v39/*: any*/),
    (v40/*: any*/)
  ],
  "storageKey": null
},
v42 = [
  (v0/*: any*/)
],
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cost",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "projectBudgetV2_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "videoIds",
          "value": [
            "budget"
          ]
        }
      ],
      "kind": "ScalarField",
      "name": "videosShown",
      "storageKey": "videosShown(videoIds:[\"budget\"])"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeatureFlag",
      "kind": "LinkedField",
      "name": "availableFeatureFlags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "xeroEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newXeroEnabled",
          "storageKey": null
        },
        (v3/*: any*/),
        {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": "ExchangeRateTypeConnection",
          "kind": "LinkedField",
          "name": "exchangeRates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExchangeRateTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ExchangeRate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v2/*: any*/),
                    (v6/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "exchangeRates(first:10000)"
        },
        {
          "alias": null,
          "args": [
            (v4/*: any*/),
            {
              "kind": "Literal",
              "name": "onlyActive",
              "value": true
            }
          ],
          "concreteType": "PersonTypeConnection",
          "kind": "LinkedField",
          "name": "allPersons",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "allPersons(first:10000,onlyActive:true)"
        },
        {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": "RateCardTypeConnection",
          "kind": "LinkedField",
          "name": "rateCards",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RateCardTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RateCard",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v7/*: any*/),
                    (v8/*: any*/),
                    (v2/*: any*/),
                    (v9/*: any*/),
                    (v13/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RateCardDropdown_rateCards"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "rateCards(first:10000)"
        },
        (v14/*: any*/),
        {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": "ExpenseCategoryTypeConnection",
          "kind": "LinkedField",
          "name": "expenseCategories",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExpenseCategoryTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ExpenseCategory",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v7/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "disabled",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "expenseCategories(first:10000)"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "expensesPage_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ratesAndInternalCostPage_company"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "budgetType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "budget",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultPeriodBudgetType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultPeriodPriceAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyProjectId",
          "storageKey": null
        },
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimationUnit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minutesPerEstimationPoint",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "kind": "ScalarField",
          "name": "reportedBillablePrice",
          "storageKey": "reportedBillablePrice(newBudget:true)"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentCost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "kind": "ScalarField",
          "name": "forecastBillablePrice",
          "storageKey": "forecastBillablePrice(newBudget:true)"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "financialServiceUnInvoicedTotal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalForecastBillableHoursPrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastBillableHoursPrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastBillablePriceScopeBased",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "kind": "ScalarField",
          "name": "forecastCost",
          "storageKey": "forecastCost(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "kind": "ScalarField",
          "name": "remainingCost",
          "storageKey": "remainingCost(newBudget:true)"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reported",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastTotal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remaining",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectEndDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectEndMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectEndYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectStartDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectStartMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectStartYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectFirstDateYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectFirstDateMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectFirstDateDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectLastDateYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectLastDateMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectLastDateDay",
          "storageKey": null
        },
        (v16/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskCostCalculationType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unassignedTaskHourlyCost",
          "storageKey": null
        },
        (v17/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baselineCost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baselineProfit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baselineTargetMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useBaseline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeRegBasedPlusDoneScopeCompletion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "valueBasedProgress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "financialDataAvailability",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialNumbers",
          "kind": "LinkedField",
          "name": "financialNumbers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalRateValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "budgetVsTotalRateValue",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Company",
          "kind": "LinkedField",
          "name": "company",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": (v5/*: any*/),
              "concreteType": "ExpenseCategoryTypeConnection",
              "kind": "LinkedField",
              "name": "expenseCategories",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ExpenseCategoryTypeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ExpenseCategory",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": (v11/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "expenseCategories(first:10000)"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "XeroInvoiceType",
          "kind": "LinkedField",
          "name": "xeroInvoices",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amountTotal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amountNoTax",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amountPaid",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "registeredMinutesPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "registeredMinutesPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "remainingMinutesPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "remainingMinutesPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "plannedMinutesPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "plannedMinutesPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "costPlannedPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "costPlannedPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "pricePlannedPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "pricePlannedPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "costRemainingPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "costRemainingPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "priceRemainingPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "priceRemainingPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "costActualPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "costActualPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "priceActualPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "priceActualPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "costPlannedWorkPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "costPlannedWorkPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "pricePlannedWorkPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "pricePlannedWorkPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "costRemainingWorkPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "costRemainingWorkPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "priceRemainingWorkPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "priceRemainingWorkPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "costActualWorkPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "costActualWorkPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "priceActualWorkPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "priceActualWorkPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "pricePlannedExpensesPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "pricePlannedExpensesPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "costPlannedExpensesPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "costPlannedExpensesPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "priceActualExpensesPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "priceActualExpensesPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "costActualExpensesPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "costActualExpensesPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "priceRemainingExpensesPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "priceRemainingExpensesPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "costRemainingExpensesPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "costRemainingExpensesPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "invoicedPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "invoicedPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": (v15/*: any*/),
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "totalPaymentsPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": "totalPaymentsPerDay(newBudget:true)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "baselinePricePerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "baselineCostPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "baselineProfitPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "baselineMinutesPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "baselineUnplannedPricePerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DateValueType",
          "kind": "LinkedField",
          "name": "baselineUnplannedMinutesPerDay",
          "plural": true,
          "selections": (v18/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownForecastMinutesPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownRemainingMinutesPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownActualMinutesPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownCostForecastPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownCostRemainingPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownCostActualPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownPricePlannedPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownPriceRemainingPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownPriceActualPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownCostForecastWorkPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownCostRemainingWorkPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownCostActualWorkPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownPricePlannedWorkPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownPriceRemainingWorkPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownPriceActualWorkPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownBaselinePricePerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownBaselineCostPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownBaselineProfitPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownBaselineMinutesPerDay",
          "plural": true,
          "selections": (v21/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownBaselineExpensesPricePerDay",
          "plural": true,
          "selections": (v22/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownBaselineExpensesCostPerDay",
          "plural": true,
          "selections": (v22/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownExpensesPlannedPricePerDay",
          "plural": true,
          "selections": (v22/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownExpensesActualsPricePerDay",
          "plural": true,
          "selections": (v22/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownExpensesRemainingPricePerDay",
          "plural": true,
          "selections": (v22/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownExpensesPlannedCostPerDay",
          "plural": true,
          "selections": (v22/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownExpensesActualsCostPerDay",
          "plural": true,
          "selections": (v22/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
          "kind": "LinkedField",
          "name": "breakdownExpensesRemainingCostPerDay",
          "plural": true,
          "selections": (v22/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectFinancialWarningType",
          "kind": "LinkedField",
          "name": "warnings",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v23/*: any*/),
            (v24/*: any*/),
            (v25/*: any*/),
            {
              "alias": null,
              "args": (v5/*: any*/),
              "concreteType": "TaskTypeConnection",
              "kind": "LinkedField",
              "name": "tasks",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TaskTypeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Task",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v7/*: any*/),
                        (v26/*: any*/),
                        (v27/*: any*/),
                        (v28/*: any*/),
                        (v29/*: any*/),
                        (v30/*: any*/),
                        (v31/*: any*/),
                        (v32/*: any*/),
                        (v33/*: any*/),
                        (v34/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "tasks(first:10000)"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "personIds",
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v5/*: any*/),
              "concreteType": "ExpenseItemTypeConnection",
              "kind": "LinkedField",
              "name": "expenseItems",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ExpenseItemTypeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ExpenseItem",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v7/*: any*/),
                        (v35/*: any*/),
                        (v36/*: any*/),
                        (v37/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "expenseItems(first:10000)"
            },
            {
              "alias": null,
              "args": (v5/*: any*/),
              "concreteType": "TimeRegTypeConnection",
              "kind": "LinkedField",
              "name": "timeRegistrations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeRegTypeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TimeRegType",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v23/*: any*/),
                        (v24/*: any*/),
                        (v25/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "minutesRegistered",
                          "storageKey": null
                        },
                        (v41/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Task",
                          "kind": "LinkedField",
                          "name": "task",
                          "plural": false,
                          "selections": [
                            (v7/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "timeRegistrations(first:10000)"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": "TaskTypeConnection",
          "kind": "LinkedField",
          "name": "tasks",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TaskTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Task",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v7/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Role",
                      "kind": "LinkedField",
                      "name": "role",
                      "plural": false,
                      "selections": (v42/*: any*/),
                      "storageKey": null
                    },
                    (v32/*: any*/),
                    (v33/*: any*/),
                    (v34/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "assignedPersons",
                      "plural": true,
                      "selections": (v42/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "tasks(first:10000)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RateCard",
          "kind": "LinkedField",
          "name": "rateCard",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v13/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": "PhaseTypeConnection",
          "kind": "LinkedField",
          "name": "phases",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PhaseTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PhaseType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v7/*: any*/),
                    (v26/*: any*/),
                    (v27/*: any*/),
                    (v28/*: any*/),
                    (v29/*: any*/),
                    (v30/*: any*/),
                    (v31/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "phases(first:10000)"
        },
        {
          "alias": "fixedPriceLocks",
          "args": null,
          "concreteType": "ProjectFixedPriceLockTypeConnection",
          "kind": "LinkedField",
          "name": "__Project_fixedPriceLocks_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectFixedPriceLockTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectFixedPriceLockType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v10/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "actualRevenueProjectCurrency",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "progress",
                      "storageKey": null
                    },
                    (v43/*: any*/)
                  ],
                  "storageKey": null
                },
                (v44/*: any*/)
              ],
              "storageKey": null
            },
            (v45/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": "expenseItems",
          "args": null,
          "concreteType": "ExpenseItemTypeConnection",
          "kind": "LinkedField",
          "name": "__Project_expenseItems_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExpenseItemTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ExpenseItem",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ExpenseCategory",
                      "kind": "LinkedField",
                      "name": "category",
                      "plural": false,
                      "selections": (v11/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PhaseType",
                      "kind": "LinkedField",
                      "name": "phase",
                      "plural": false,
                      "selections": (v11/*: any*/),
                      "storageKey": null
                    },
                    (v7/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "approved",
                      "storageKey": null
                    },
                    (v35/*: any*/),
                    (v36/*: any*/),
                    (v37/*: any*/),
                    (v16/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "price",
                      "storageKey": null
                    },
                    (v46/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "quantity",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "planned",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "invoiced",
                      "storageKey": null
                    },
                    (v41/*: any*/),
                    (v43/*: any*/)
                  ],
                  "storageKey": null
                },
                (v44/*: any*/)
              ],
              "storageKey": null
            },
            (v45/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1000
            }
          ],
          "concreteType": "ProjectPersonTypeConnection",
          "kind": "LinkedField",
          "name": "projectPersons",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectPersonTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectPerson",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "person",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isViewer",
                          "storageKey": null
                        },
                        (v38/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "initials",
                          "storageKey": null
                        },
                        (v39/*: any*/),
                        (v40/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "active",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "userType",
                          "storageKey": null
                        },
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": (v5/*: any*/),
                          "concreteType": "CostPeriodTypeConnection",
                          "kind": "LinkedField",
                          "name": "costPeriods",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "CostPeriodTypeEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "CostPeriod",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v0/*: any*/),
                                    (v26/*: any*/),
                                    (v27/*: any*/),
                                    (v28/*: any*/),
                                    (v46/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": "costPeriods(first:10000)"
                        }
                      ],
                      "storageKey": null
                    },
                    (v12/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "projectPersons(first:1000)"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 100000000
            }
          ],
          "concreteType": "InvoiceTypeConnection",
          "kind": "LinkedField",
          "name": "invoices",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "InvoiceTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "InvoiceType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v17/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "invoices(first:100000000)"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "expensesPage_project"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ratesAndInternalCostPage_project"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd3750f5bd6970f0d4076ed244f8424f5';

module.exports = node;
